<template>
  <div>
    <nav class="translucent">
      <div class="container">
        <div class="brand-logo">
          <div class="img">
            <img :src="require('@/assets/logo.png')" alt="">
          </div>
        </div>
        <div class="right">
          <!-- <span class="">Blog</span> -->
          <router-link class="btn outline" :to="{ name: 'Landing' }">
            Go Home
          </router-link>
        </div>
      </div>
    </nav>

    <header class="row vcenter">
      <div class="backdrop">
        <div class="overlay"></div>
        <img :src="require('@/assets/images/banner_auth.jpg')" alt="" />
      </div>
      <div class="container">
        <router-view></router-view>
      </div>
    </header>
  </div>
</template>

<script>
// TODO Update to use new error format
/*
Error Format:
  --> {err_field: [err_values: str; *]}
*/

export default {
  name: "Auth"
};
</script>

<style lang="scss" scoped>
nav {
  position: fixed;
  color: white;
  background-color: #00000050;

  @supports((backdrop-filter: blur(20px))) {
    backdrop-filter: blur(20px);
    background-color: #00000039;
  }
}
header {
  height: 100vh;
}

.container {
  width: 100%;
}
</style>
